// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { SimpleBarChart } from '@/components/composite/Charts/SimpleBarChart';

export const avgEngagementsPerPostTypeConfig = {
    title: 'chart.instagram.avg_engagement_post_type',
    noLegend: true,
    tickFormatterTranslation: 'analytics:chart.post_type_instagram',
    tableColumnFormatterTranslation: 'analytics:chart.post_type_instagram',
    margin: {
        left: -40
    },
    name: {
        type: 'chart.instagram.avg_reach_post_type_type',
        value: 'chart.instagram.avg_reach_post_type_value',
        avg: 'chart.instagram.avg_reach_post_type_average'
    },
    id: 'average_engagements_per_post_type',
    social: INSTAGRAM,
    valueFormat: classicFormat,
    color: {
        value: 'green',
        avg: 'gray'
    },
    size: SIZE_50,
    type: 'chart',
    element: SimpleBarChart,
    new: {
        dateAdded: '2025-10-29'
    }
};
